(function () {
  'use strict';

  if (window.__eusariMarketAwareRuntimeInitialized) return;
  window.__eusariMarketAwareRuntimeInitialized = true;

  function parsePayload(selector) {
    var payloadNode = document.querySelector(selector);
    if (!payloadNode) return null;
    try {
      return JSON.parse(payloadNode.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  var payloads = {
    header: parsePayload('[data-eusari-active-menu]'),
    footer: parsePayload('[data-eusari-active-footer-menu]')
  };

  function normalizeKey(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function isValidUrl(value) {
    if (!value || typeof value !== 'string') return false;
    var trimmed = value.trim();
    if (!trimmed || trimmed === '#') return false;
    if (/^(javascript|data|vbscript):/i.test(trimmed)) return false;
    try {
      var url = new URL(trimmed, window.location.origin);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch (error) {
      return false;
    }
  }

  function resolveLink(payload, key) {
    var links = Array.isArray(payload && payload.links) ? payload.links.slice() : [];
    if (Array.isArray(payload && payload.canonical_links)) {
      links = links.concat(payload.canonical_links);
    }
    var byKey = Object.create(null);
    links.forEach(function (link) {
      var normalizedKey = link && normalizeKey(link.key);
      if (!normalizedKey) return;
      var existing = byKey[normalizedKey];
      if (!existing || (!isValidUrl(existing.url) && isValidUrl(link.url))) {
        byKey[normalizedKey] = link;
      }
    });
    var normalizedKey = normalizeKey(key);
    var link = normalizedKey ? byKey[normalizedKey] : null;
    if (!link) return { link: null, reason: 'missing-menu-entry' };
    if (!isValidUrl(link.url)) return { link: null, reason: 'invalid-menu-entry' };
    return { link: link, reason: null };
  }

  function notifyMarketLinkResolved(anchor) {
    try {
      document.dispatchEvent(new CustomEvent('eusari:market-link-resolved', {
        detail: { anchor: anchor }
      }));
    } catch (error) {
      // The journey decorator is optional; the resolved link stays valid without it.
    }
  }

  function processLink(anchor) {
    if (!anchor || anchor.nodeType !== 1 || !anchor.matches('[data-market-aware-link]')) return;
    if (anchor.getAttribute('data-market-aware-processed') === 'true') return;
    anchor.setAttribute('data-market-aware-processed', 'true');
    var context = anchor.getAttribute('data-market-context') === 'footer' ? 'footer' : 'header';
    var payload = payloads[context];
    var key = anchor.getAttribute('data-market-destination') || '';
    var originalUrl = anchor.getAttribute('data-market-original-url') || '';
    var fallbackUrl = anchor.getAttribute('data-market-fallback-url') || (payload && payload.root_url) || '/';
    var preserveFragment = anchor.getAttribute('data-market-preserve-fragment') === 'true';
    var resolution = resolveLink(payload, key);
    var resolved = resolution.link;

    if (resolved) {
      var resolvedUrl = resolved.url;
      if (preserveFragment && originalUrl) {
        try {
          var originalFragment = new URL(originalUrl, window.location.origin).hash;
          var resolvedFragment = new URL(resolvedUrl, window.location.origin).hash;
          if (originalFragment && !resolvedFragment) {
            resolvedUrl += originalFragment;
          }
        } catch (error) {
          // Keep the existing resolved URL when either URL cannot be parsed.
        }
      }
      anchor.setAttribute('href', resolvedUrl);
      anchor.setAttribute('data-market-resolved-url', resolvedUrl);
      anchor.setAttribute('data-market-resolution', 'active-menu');
      anchor.setAttribute('data-market-source', resolved.source || 'active-menu');
      anchor.removeAttribute('data-market-fallback-reason');
      notifyMarketLinkResolved(anchor);
      return;
    }

    var safeFallback = isValidUrl(fallbackUrl) ? fallbackUrl : ((payload && payload.root_url) || '/');
    anchor.setAttribute('href', safeFallback);
    anchor.setAttribute('data-market-resolved-url', safeFallback);
    anchor.setAttribute('data-market-resolution', 'fallback');
    anchor.setAttribute('data-market-fallback-reason', resolution.reason || (!originalUrl ? 'missing-menu-entry' : 'invalid-menu-entry'));
    notifyMarketLinkResolved(anchor);
  }

  function processLinks(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('[data-market-aware-link]')) processLink(root);
    root.querySelectorAll('[data-market-aware-link]').forEach(processLink);
  }

  processLinks(document);

  if (window.MutationObserver && document.body) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) processLinks(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}());
